import { useAtom } from 'jotai';
import { Pencil } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { TextArea } from '@/components/ui/text-area';
import { cn } from '@/lib/utils';

import { magicEditPromptAtom } from '../atoms/prompt';

type Props = {
  className?: string;
};

export const MagicEditInstructions = ({ className }: Props) => {
  const { t } = useTranslation();
  const [prompt, setPrompt] = useAtom(magicEditPromptAtom);

  return (
    <div className={cn('w-full rounded-sm border border-slate-200 bg-white p-3', className)}>
      <div className="flex items-center gap-2 py-2 text-[12px] font-semibold text-slate-500">
        <Pencil aria-hidden className="size-5 text-slate-500" />
        <span>
          {t('instructions')}
          <span aria-hidden>*</span>
        </span>
        <span className="sr-only">{t('required')}</span>
      </div>

      <TextArea
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder={t('instructionsPlaceholder')}
        color="primary"
        className={cn(
          'mt-2 h-[86px] min-h-[86px] w-full resize-none overflow-y-auto rounded-sm border border-slate-200 bg-white px-3 py-2 text-xs font-medium text-slate-700 outline-none',
          'placeholder:text-slate-400 focus-visible:border-primary-light'
        )}
        wrapperClassName="h-auto w-full overflow-hidden"
      />
    </div>
  );
};
